import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryMultipleDegreeType extends TitleBase {
	private degreeTypeValue: string;

	protected canHandle(): boolean {
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);

		return (
			this.indexableFilters.length === 1 &&
			this.multiValueFilters.length >= 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.degreeTypeValue} in selected countries`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${degreeTypeValue} in selected countries | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.degreeTypeValue, ' in selected countries');
	}
}
